// // google-maps.service.ts

// import { Injectable } from '@angular/core';

// declare var google: any; // Add this line to declare `google` globally

// @Injectable({
//   providedIn: 'root',
// })
// export class GoogleMapsService {
//   private googleMapsLoaded = false;

//   loadGoogleMaps(apiKey: string): Promise<void> {
//     return new Promise((resolve, reject) => {
//       if (this.googleMapsLoaded) {
//         resolve();
//         return;
//       }

//       const script = document.createElement('script');
//       script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
//       script.async = true;
//       script.defer = true;
//       script.onload = () => {
//         this.googleMapsLoaded = true;
//         resolve();
//       };
//       script.onerror = (error) => {
//         reject(error);
//       };

//       document.head.appendChild(script);
//     });
//   }

//   isGoogleMapsLoaded(): boolean {
//     return typeof google !== 'undefined' && google.maps !== undefined;
//   }
// }


// <script
// src="https://maps.googleapis.com/maps/api/js?key=AIzaSyAJIOTerZhOVZK1euJfrVjCeEhFruCqgnA&libraries=places"
// async>

import { Injectable } from '@angular/core';

declare var google: any;

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsService {
  private googleMapsLoaded = false;

  loadGoogleMaps(apiKey: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.googleMapsLoaded) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.googleMapsLoaded = true;
        resolve();
      };
      script.onerror = (error) => {
        reject(error);
      };

      document.head.appendChild(script);
    });
  }

  isGoogleMapsLoaded(): boolean {
    return typeof google !== 'undefined' && google.maps !== undefined;
  }
}
